<div class="welcome-wizard-key-indicator-page-container container" fxLayout="column" fxLayoutGap="15px"
     [formGroup]="form">
  <p>{{ 'key_indicator.description' | translate }}</p>

  <mat-radio-group color="primary" formControlName="primaryKeyIndicator" fxLayout="column" fxLayoutGap="5px" aria-label="Select Primary Key Indicator">
    <mat-radio-button [value]="KeyIndicatorType.SALES_SQFT">{{ 'key_indicator.sales_sqft' | translate }}</mat-radio-button>
    <mat-radio-button [value]="KeyIndicatorType.SALES_VOLUME">{{ 'key_indicator.sales_volume' | translate }}</mat-radio-button>
  </mat-radio-group>
</div>
